import(/* webpackMode: "eager" */ "/workspace/node_modules/.pnpm/next@15.2.2_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["AnimatedLoading"] */ "/workspace/src/components/ui/animated-title.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/components/ui/catalog/client/catalog-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/ui/catalog/commission/detail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/ui/catalog/drop/detail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/ui/catalog/exhibition/detail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/ui/catalog/immersive/detail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/ui/catalog/installation/detail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/ui/catalog/physical/detail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FixedLayout"] */ "/workspace/src/components/ui/layout/fixed-layout.tsx");
